// Utility to extract and determine the cookie domain from environment URLs

/**
 * Extract domain from a URL
 * @param {string} url - Full URL
 * @returns {string|null} - Domain or null if invalid
 */
const extractDomain = (url) => {
  if (!url) return null;
  try {
    const urlObj = new URL(url);
    return urlObj.hostname;
  } catch (e) {
    return null;
  }
};

/**
 * Get the common domain for cookie sharing across all app URLs
 * Returns the base domain (e.g., "redfid.cl" from "www.redfid.cl")
 * This allows cookies to work across subdomains
 */
export const getCookieDomain = () => {
  const urls = [
    process.env.REACT_APP_HOME_URL,
    process.env.REACT_APP_CURSOS_URL,
    process.env.REACT_APP_COMUNIDADES_URL,
    process.env.REACT_APP_RECURSOS_URL,
    process.env.REACT_APP_ADMIN_URL,
    process.env.REACT_APP_DASHBOARD_URL
  ].filter(Boolean);

  if (urls.length === 0) {
    return null;
  }

  // Extract domains from all URLs
  const domains = urls.map(extractDomain).filter(Boolean);
  
  if (domains.length === 0) {
    return null;
  }

  // Find common base domain
  // For example: www.redfid.cl, cursos.redfid.cl -> .redfid.cl
  const firstDomain = domains[0];
  
  // If it's localhost, return null (cookies work across ports on localhost)
  if (firstDomain === 'localhost' || firstDomain.startsWith('127.0.0.1')) {
    return null;
  }

  // Extract base domain (remove subdomain)
  // Split by dots and take last two parts (e.g., redfid.cl)
  const parts = firstDomain.split('.');
  if (parts.length >= 2) {
    // Return base domain with leading dot for subdomain support
    const baseDomain = parts.slice(-2).join('.');
    return `.${baseDomain}`;
  }

  return null;
};
